import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

const LOGO_URL = "https://ixcateopandecuauhtemocgro.gob.mx/vendor/municipio/assets/img/logo.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem("transito_remember_email");
    if (saved) {
      setEmail(saved);
      setRemember(true);
    }
    document.title = "Inicio de sesión";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) {
      setError("Por favor completa todos los campos.");
      return;
    }
    setLoading(true);
    try {
      if (remember) localStorage.setItem("transito_remember_email", email);
      else localStorage.removeItem("transito_remember_email");
      await login(email.trim().toLowerCase(), password);
      toast.success("Bienvenido");
      navigate("/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Credenciales no válidas";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bg-overlay" />
      <div className="page-wrapper">
        <div className="login-container animate-fade-in">
          <form onSubmit={handleSubmit} method="POST" noValidate>
            <div className="login-form">
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "1.5rem" }}>
                <img
                  src={LOGO_URL}
                  alt="Ixcateopan de Cuauhtémoc - Gobierno Municipal"
                  style={{ width: "220px", maxWidth: "80%", height: "auto", display: "block" }}
                />
              </div>

              <div style={{ marginBottom: "1.25rem" }}>
                <input
                  type="email"
                  className="form-control-custom"
                  placeholder="Ingresa tu usuario"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  data-testid="login-email-input"
                />
              </div>

              <div style={{ marginBottom: "1.25rem", position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control-custom"
                  placeholder="Ingresa tu contraseña"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  data-testid="login-password-input"
                  style={{ paddingRight: "2.5rem" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  data-testid="toggle-password-btn"
                  aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#6b7280",
                  }}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>

              <div style={{ marginBottom: "1.25rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="remember"
                  id="flexCheckDefault"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                />
                <label
                  htmlFor="flexCheckDefault"
                  style={{ fontSize: "0.95rem", color: "#212529", cursor: "pointer", userSelect: "none" }}
                >
                  Recordarme
                </label>
              </div>

              {error && (
                <div
                  role="alert"
                  data-testid="login-error-msg"
                  style={{
                    backgroundColor: "#f8d7da",
                    color: "#842029",
                    border: "1px solid #f5c2c7",
                    padding: "0.5rem 0.75rem",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                    marginBottom: "1rem",
                  }}
                >
                  {error}
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "66.6667%" }}>
                  <button type="submit" className="btn-rojo" disabled={loading} data-testid="login-submit-btn">
                    {loading ? (
                      <>
                        <span className="btn-spinner" />
                        Entrando...
                      </>
                    ) : (
                      "Entrar"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
